<template>
    <div id="app" v-cloak>
        <!-- pc -->
        <Pc v-if="!isMobile" :language="language" @handleLang="handleLang"></Pc>
        <!-- 移动端 -->
        <Mobile v-if="isMobile" :language="language" @handleLang="handleLang"></Mobile>
    </div>
</template>

<script>
import Pc from '@/components/pc'
import Mobile from '@/components/mobile'
import queryString from 'query-string'

const parsed = queryString.parse(location.search || '') || {}
export default {
    name: 'App',
    data() {
        return {
            language: 'en',
            isMobile: false
        }
    },
    components: {
        Pc,
        Mobile
    },
    created() {
        window.location.href = 'https://store.habby.com/game/5?page=giftcode';
    },
    mounted() {
        this.init();
        this.initLANG();
        this.checkIfMobile();
        if (parsed.clear) {
            localStorage.clear();
        }
    },
    methods: {
        initLANG() {
            let language = navigator.language.toLowerCase()
            if (parsed.gameLanguage) {
                language = parsed.gameLanguage
            }
            console.log(language, 'gameLanguage')
            if (language.startsWith('zh')) {
                if ('zh-cn' == language || 'zh-CN' == language || 'zh' == language) {
                    this.language = 'en'
                } else {
                    this.language = 'zh-TW'
                }
            } else if (language.startsWith('ja')) {
                this.language = 'ja'
            } else if (language.startsWith('ko')) {
                this.language = 'ko'
            }  else {
                this.language = 'en'
            }
        },
        handleLang(val){
            this.language = val;
        },
        // 区分移动还是pc
        checkIfMobile() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            this.isMobile = /android|webos|iphone|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
        },
        init() {
            // 禁止双指放大
            document.documentElement.addEventListener(
                'touchstart',
                function (event) {
                    if (event.touches.length > 1) {
                        event.preventDefault()
                    }
                },
                false
            )
            var lastTouchEnd = 0
            document.documentElement.addEventListener(
                'touchend',
                function (event) {
                    var now = Date.now()
                    if (now - lastTouchEnd <= 300) {
                        event.preventDefault()
                    }
                    lastTouchEnd = now
                },
                false
            )
        },
    }
}
</script>

<style lang="less">
html,
body {
    min-height: 100%;
    text-align: center;
    font-family: 'MicrosoftYaHei' !important;
}
#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
/*公共样式--开始*/
html,
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
p,
form,
input,
textarea,
select {
    margin: 0;
    padding: 0;
}
* {
    box-sizing: border-box;
}
img {
    border: none;
    vertical-align: middle;
    user-select: none; /* 禁止选中 */
}

a {
    text-decoration: none;
    color: #232323;
}

table {
    border-collapse: collapse;
    table-layout: fixed;
}
input,
textarea {
    outline: none;
    border: none;
}
.el-scrollbar {
    .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/App.vue